"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Actions;

var _react = _interopRequireDefault(require("react"));

var _Pageview = _interopRequireDefault(require("@material-ui/icons/Pageview"));

var _AddCircle = _interopRequireDefault(require("@material-ui/icons/AddCircle"));

var _Edit = _interopRequireDefault(require("@material-ui/icons/Edit"));

var _Cancel = _interopRequireDefault(require("@material-ui/icons/Cancel"));

var _CheckCircle = _interopRequireDefault(require("@material-ui/icons/CheckCircle"));

var _core = require("@material-ui/core");

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function Actions(_ref) {
  var _ref$label = _ref.label,
      label = _ref$label === void 0 ? {
    view: "View Detail",
    done: "Done",
    cancel: "Cancel",
    add: "Add",
    edit: "Edit"
  } : _ref$label,
      onClickDetail = _ref.onClickDetail,
      onClickDone = _ref.onClickDone,
      onClickCancel = _ref.onClickCancel,
      onClickAdd = _ref.onClickAdd,
      onClickEdit = _ref.onClickEdit,
      children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: "flex"
    }
  }, onClickDetail && /*#__PURE__*/_react["default"].createElement(_core.Tooltip, {
    title: label && label.view
  }, /*#__PURE__*/_react["default"].createElement(_core.IconButton, {
    size: "small",
    onClick: onClickDetail
  }, /*#__PURE__*/_react["default"].createElement(_Pageview["default"], {
    fontSize: "small"
  }))), onClickDone && /*#__PURE__*/_react["default"].createElement(_core.Tooltip, {
    title: label && label.done
  }, /*#__PURE__*/_react["default"].createElement(_core.IconButton, {
    size: "small",
    onClick: onClickDone
  }, /*#__PURE__*/_react["default"].createElement(_CheckCircle["default"], {
    fontSize: "small"
  }))), onClickCancel && /*#__PURE__*/_react["default"].createElement(_core.Tooltip, {
    title: label && label.cancel
  }, /*#__PURE__*/_react["default"].createElement(_core.IconButton, {
    size: "small",
    onClick: onClickCancel
  }, /*#__PURE__*/_react["default"].createElement(_Cancel["default"], {
    fontSize: "small"
  }))), onClickAdd && /*#__PURE__*/_react["default"].createElement(_core.Tooltip, {
    title: label && label.add
  }, /*#__PURE__*/_react["default"].createElement(_core.IconButton, {
    size: "small",
    onClick: onClickAdd
  }, /*#__PURE__*/_react["default"].createElement(_AddCircle["default"], {
    fontSize: "small"
  }))), onClickEdit && /*#__PURE__*/_react["default"].createElement(_core.Tooltip, {
    title: label && label.edit
  }, /*#__PURE__*/_react["default"].createElement(_core.IconButton, {
    size: "small",
    onClick: onClickEdit
  }, /*#__PURE__*/_react["default"].createElement(_Edit["default"], {
    fontSize: "small"
  }))), children);
}

Actions.propTypes = {
  label: _propTypes["default"].shape({
    view: _propTypes["default"].string,
    done: _propTypes["default"].string,
    cancel: _propTypes["default"].string,
    add: _propTypes["default"].string,
    edit: _propTypes["default"].string
  }),
  onClickDetail: _propTypes["default"].func,
  onClickDone: _propTypes["default"].func,
  onClickCancel: _propTypes["default"].func,
  onClickAdd: _propTypes["default"].func,
  onClickEdit: _propTypes["default"].func
};